export const ProductionSimulationThroughputItem = (
	json: IProductionSimulationThroughputItem,
): IProductionSimulationThroughputItemModel => {
	const {
		id,
		meal_id,
		meal_ingredients,
		meals_quantity,
		number_of_people,
		packaging_start_available_at,
		packaging_throughput,
		product_name,
		total_packing_time,
	} = json

	return {
		id,
		mealID: meal_id,
		mealIngredients: meal_ingredients,
		mealsQuantity: meals_quantity,
		numberOfPeople: number_of_people,
		packagingStartAvailableAt: packaging_start_available_at,
		packagingThroughput: packaging_throughput,
		productName: product_name,
		totalPackingTime: total_packing_time,
	}
}

export const ProductionSimulationThroughput = (
	json: IProductionSimulationThroughput,
): IProductionSimulationThroughputModel => {
	const { assigned_position_id, items, position_name } = json

	return {
		assignedPositionID: assigned_position_id,
		items: items.map(ProductionSimulationThroughputItem),
		positionName: position_name,
	}
}
